import React from "react";

const Priprava = () => {
  return (
    <div>
      <h1>Priprava</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Priprava;